import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import { deepOrange } from '@mui/material/colors';

export default function Avatars() {
  return (
    <Avatar sx={{ bgcolor: deepOrange[500] }}>N</Avatar>
  );
}